import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Box, Button, CircularProgress, IconButton, Radio, Tooltip, Typography } from "@mui/material";
import { useStyles } from "../../styles";
import { useTranslation } from "react-i18next";
import { CustomPaper } from "../../../../../../../../../../components/CustomPaper";
import { reportFolioServices } from "../../../../../../../../../../utils/constants/callService";
import { ConfirmModal } from "../ConfirmModal";
import { useParams } from "react-router-dom";
import { SnackSimple } from "../../../../../../../../../../components";
import { Types } from "../../../../../../../../../../utils/enums/types";
import format from "date-fns/format";
import es from "date-fns/locale/es";
import { icons } from "../../../../../../../../../../utils/icons";
import { Constants } from "../../../../../../../../../../utils/constants";
import { AnswerTypeHistory } from "../../../../enums/answerType";
import { VIEW_TYPES } from "../../../../types/ViewTypes";
import { getLocalStorage } from "../../../../../../../../../../utils/crud/crypt";
import { Roles } from "../../../../../../../../../../utils/enums";
import { Evidence } from "../../../../../../../../../../service/reportFolio/response";
import { ActionDrawer } from "../../../../../../../../../../components/ActionDrawer";
import EvidenceDetail from "../../../../../../../../../actionPlans/pages/form/components/evidenceDetail";
import { useEvidences } from "../../../../../../../../../../hooks/evidences/useEvidences";
import { useEvidenceDownload } from "../../../../../../../../../calendar/pages/detail/hooks";
import { User } from "../../../../../../../../../../components/layout/aside/types";
import { Priority } from "../../../../../../../../../../utils/enums/priority";

interface UserAssign {
    id: number;
    firstName: string;
    lastName: string;
}

interface RequestIntructionInterface {
    items: Array<{
        id: number;
        instructionSubmitted: boolean;
        instruction: {
            id: number,
            reportFolioId: number,
            userId: number,
            evidencesInstruction: Evidence[] | undefined,
            instruction: string | null,
            userCreatorId: number,
            createTime: string | null,
            updateTime: string | null,
            deleteTime: string | null
        } | null;
        type: string;
        dateRequestCreateFolio: string;
        usersAssings: UserAssign[];
        userManageDepartment: number;
        userManagersDeparment: number[];
        newStep: string;
        typeHistory: string;
        requestSubmitted: boolean
        dateRequestQuote: string;
    }>;
    options: {
        id: number;
        label: string;
        value: string;
        check: boolean;
    }[];
    setOptions: Dispatch<SetStateAction<{
        id: number;
        label: string;
        value: string;
        check: boolean;
    }[]>>
    reload: () => void;
    left: any
    disabled: boolean
    onAttend: any
}

export const RequestIntruction = ({ items, reload, left, disabled, options, setOptions, onAttend }: RequestIntructionInterface) => {
    const styles = useStyles();
    const { t } = useTranslation();
    const { id: reportFolioId } = useParams<{ id: string }>();
    const [isModalOpen, setModalOpen] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);
    const [alertModals, setAlertModals] = useState(false);
    const [messageAlertModals, setMessageAlertModals] = useState("");
    const [isConfigLoading, setIsConfigLoading] = useState(true);
    const lastRequestQuote = items
        ?.filter((item) => item.type === AnswerTypeHistory.COMMENT_INSTRUCTON)
        .sort((a, b) => a.index - b.index)
        .at(0);

    const provider =
        lastRequestQuote?.usersAssings?.[0]
            ? `${lastRequestQuote.usersAssings[0].firstName} ${lastRequestQuote.usersAssings[0].lastName}`
            : t("reportFolio.detail.general.noAssignedUser");

    const formattedDate = lastRequestQuote?.instruction?.createTime
        ? format(new Date(lastRequestQuote.instruction?.createTime), Constants.dateFormatGeneral3, { locale: es })
        : t("reportFolio.detail.general.noDateAvailable");

    const isSubmitted = lastRequestQuote?.instructionSubmitted

    const commentIntructionText = lastRequestQuote?.instruction?.instruction || "";

    const { evidences, existEvidences } = useEvidences({
        evidencesResponse: lastRequestQuote?.instruction?.evidencesInstruction,
        manualValue: false,
    });

    const userData: User = getLocalStorage()
    const [localeOptions, setLocaleOptions] = useState(options);

    const { disable: isDownloading, downloadEvidences, } = useEvidenceDownload('evidencias', lastRequestQuote?.instruction?.evidencesInstruction);

    const handleConfirm = async () => {
        if (!lastRequestQuote?.usersAssings?.[0]?.id || !reportFolioId) return;

        const payload = {
            reportFolioId: Number(reportFolioId),
            description: "", // Enviar descripción vacía
            userReviewer: lastRequestQuote.usersAssings[0].id,
        };

        setSubmitting(true);

        try {
            const response = await reportFolioServices.requestQuote(payload);
            if (response.code === "00") {
                setMessageAlertModals(t("reportFolio.detail.general.confirmQuotationTitleSucces"));
                setAlertModals(true); // Muestra el snackbar
                setModalOpen(false);
            } else {
                setMessageAlertModals(t("reportFolio.detail.general.confirmQuotationTitleError"));
                setAlertModals(true); // Muestra el snackbar
                setModalOpen(false);
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
        } finally {
            setSubmitting(false);
        }
    };

    const handleCloseAlertsModal = () => {
        setAlertModals(false); // Oculta el snackbar
    };

    useEffect(() => {

        const isHighPriority = left.priority.id == Priority.HIGH || left.priority.id == Priority.URGENT;
        const hasAssignedUser = lastRequestQuote?.usersAssings?.[0];
        const isAdminOrManager = userData.role == Roles.ADMIN || lastRequestQuote?.userManagersDeparment.find(idUser => idUser == userData.id);;


        const filtered = options.filter(opt => {
            switch (opt.value) {
                case 'QUOTE':
                    return (
                        !isSubmitted
                    );

                case 'SOLUTION':
                    return (
                        !isSubmitted &&
                        !hasAssignedUser &&
                        !isHighPriority &&
                        isAdminOrManager
                    );

                default:
                    return true;
            }
        });

        const normalized = filtered;

        setLocaleOptions(normalized);
        setIsConfigLoading(false);

    }, [])

    if (isConfigLoading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "150px" }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <>
            {localeOptions?.length > 1 && <Box>
                {localeOptions.map(option => (
                    <>
                        <Radio
                            name="option"
                            checked={option.check}
                            onClick={() => {
                                setOptions(prev => prev.map(opt => ({ ...opt, check: opt.value === option.value })));
                            }}
                        />
                        <Typography variant="subtitle_grey">{option.label}</Typography></>
                ))}
            </Box>}
            <CustomPaper sx={styles.userContainer} elevation={3}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    {/* Sección del texto */}
                    <Box>
                        <Typography sx={styles.title(2)}>
                            {isSubmitted ? (
                                <Box display="flex" alignItems="center">
                                    {icons("info")}
                                    <span style={{ marginLeft: '8px' }}>
                                        {t(`reportFolio.detail.general.commentIntructionProviderSend`)}
                                    </span>
                                </Box>
                            ) : (
                                t(`reportFolio.detail.general.commentIntructionTitle`)
                            )}
                        </Typography>

                        <Typography variant="body2">
                            {isSubmitted ?
                                t("reportFolio.detail.general.providerAssignedAndDate", { Date: formattedDate }) :
                                t("reportFolio.detail.general.providerAssigned", { provider })}
                        </Typography>
                    </Box>

                    {/* Sección de botones */}
                    {!isSubmitted ? (
                        <Box display="flex" gap={2}>
                            <Button
                                variant="contained"
                                onClick={() => onAttend(VIEW_TYPES.SEND_SOLUTION)}
                                disabled={isSubmitting /* || !lastRequestQuote?.usersAssings?.[0] */ || disabled}
                            >
                                {t("reportFolio.detail.general.sendIntructionComment")}
                            </Button>
                        </Box>
                    ) : <>

                    </>}

                </Box>
                {isSubmitted && (
                    <Box>
                        <Typography variant="body1">
                            {t("reportFolio.detail.general.instructionSendMessage")}
                        </Typography>

                        <Typography variant="body1"
                            sx={{
                                '&.MuiTypography-root':
                                    { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", mt: 3 }
                            }}
                        >
                            {commentIntructionText}
                        </Typography>
                    </Box>
                )}

                {isSubmitted &&
                    <Box display="flex" alignItems="center" justifyContent={'end'} gap={2}>
                        <ActionDrawer
                            title="EVIDENCIAS"
                            body={
                                <Box sx={styles.mainContainer}>
                                    <Box sx={styles.bodyContainer}>
                                        <EvidenceDetail
                                            existEvidences={existEvidences}
                                            evidences={{
                                                image: evidences?.images,
                                                comment: evidences?.comments,
                                                documents: evidences?.documents,
                                                video: evidences?.video,
                                                sign: evidences?.sign
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <Button variant='text_primary_small' onClick={downloadEvidences} disabled={isDownloading}>{t('schedule.buttons.downloadEvidence')}</Button>
                                    </Box>
                                </Box>
                            }
                        >
                            {
                                ({ openDrawer }) =>
                                    <Tooltip title={t("ToolTips.seeEvidences")}>
                                        <IconButton
                                            onClick={() => { openDrawer() }}
                                            sx={styles.clip}
                                            disabled={!existEvidences}
                                        >
                                            {icons("clip")}
                                        </IconButton>
                                    </Tooltip>
                            }
                        </ActionDrawer>
                    </Box>
                }


            </CustomPaper>

            {/* Confirm Modal */}
            <ConfirmModal
                open={isModalOpen}
                simpleText
                onClose={() => setModalOpen(false)}
                onConfirm={handleConfirm}
                title={t("reportFolio.detail.general.confirmQuotationTitle")}
                description={t("reportFolio.detail.general.confirmQuotationDescription", { provider: provider })}
            /* reload={reload} */
            />

            <SnackSimple
                open={alertModals}
                close={handleCloseAlertsModal}
                message={messageAlertModals}
                type={Types.SUCCESS}
            />
        </>
    );
};